import { Plus } from "lucide-react";
import React, { useEffect, useState, useCallback } from "react";
import "./PaymentReceipt.css";
import axios from "axios";
import { toast } from "react-toastify";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
// const API_URL = "https://payyug.in/api";

const PaymentReceipt = () => {
  // const [paymentReceipts, setPaymentReceipts] = useState([]);

  // // input filters
  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");

  // // applied filters
  // const [appliedFromDate, setAppliedFromDate] = useState("");
  // const [appliedToDate, setAppliedToDate] = useState("");

  // // pagination (frontend)
  // const [currentPage, setCurrentPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  // const [hasSearched, setHasSearched] = useState(false);

  // /* ================= FETCH ================= */
  // const fetchPaymentReciepts = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     setError("");

  //     const token = localStorage.getItem("authToken");

  //     const res = await axios.get(
  //       `${API_URL}/report/receipt-payment`,
  //       {
  //         params: {
  //           fromDate: appliedFromDate,
  //           toDate: appliedToDate,
  //         },
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     console.log("payment receipt:",res.data)
  //     setPaymentReceipts(res?.data || []);
  //   } catch (err) {
  //     console.error(err);
  //     setError(err?.response?.data?.message || "Failed to fetch paymentReceipts");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [appliedFromDate, appliedToDate]);

  // /* ================= FETCH AFTER SEARCH ================= */
  // useEffect(() => {
  //   if (hasSearched) {
  //     fetchPaymentReciepts();
  //   }
  // }, [fetchPaymentReciepts, hasSearched]);

  // /* ================= FILTER ================= */
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!fromDate || !toDate) {
  //       toast.error("Please select From Date and To Date")
  //     return; 
  //   }

  //   setAppliedFromDate(fromDate);
  //   setAppliedToDate(toDate);
  //   setCurrentPage(1);
  //   setHasSearched(true);
  // };

  // /* ================= PER PAGE ================= */
  // const handleItemsPerPageChange = (e) => {
  //   setRowsPerPage(Number(e.target.value));
  //   setCurrentPage(1);
  // };

  // /* ================= FRONTEND PAGINATION ================= */
  // const totalRecords = paymentReceipts.length;
  // const totalPages = Math.ceil(totalRecords / rowsPerPage);

  // const paginatedData = paymentReceipts.slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage
  // );

  return (
    // <div className="paymentReceipt-container">
    //   <h1 className="paymentReceipt-heading">Payment Receipt</h1>

    //   {/* ================= TOP ================= */}
    //   <div className="paymentReceipt-top">
    //     {/* ================= FILTER ================= */}
    //     <form className="paymentReceipt-form" onSubmit={handleSubmit}>
    //       <div className="paymentReceipt-form-section">
    //         <div className="paymentReceipt-form-input-fields">
    //           <label>From Date</label>
    //           <input
    //             type="date"
    //             value={fromDate}
    //             onChange={(e) => setFromDate(e.target.value)}
    //           />
    //         </div>

    //         <div className="paymentReceipt-form-input-fields">
    //           <label>To Date</label>
    //           <input
    //             type="date"
    //             value={toDate}
    //             onChange={(e) => setToDate(e.target.value)}
    //           />
    //         </div>
    //       </div>

    //       <div className="paymentReceipt-form-submit-btn">
    //         <button type="submit">
    //           {loading ? "Loading..." : "Get Records"}
    //         </button>
    //       </div>
    //     </form>
    //   </div>

    //   {/* ================= REPORT ================= */}
    //   <div className="paymentReceipt-report-container">
    //     <h1>Voucher Entries Report</h1>

    //     <div className="paymentReceipt-report-filter-div">
    //       <div className="paymentReceipt-filter">
    //         <label>Show </label>
    //         <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
    //           {ITEMS_PER_PAGE_OPTIONS.map((num) => (
    //             <option key={num} value={num}>
    //               {num}
    //             </option>
    //           ))}
    //         </select>
    //         <span> entries</span>
    //       </div>

    //       {hasSearched && (
    //         <div className="paymentReceipt-total-records">
    //           Total Records: {totalRecords}
    //         </div>
    //       )}
    //     </div>

    //     <div className="paymentReceipt-report-table-container">
    //       {error && <p className="error-text">{error}</p>}

    //       <table className="paymentReceipt-report-table">
    //         <thead>
    //           <tr>
    //             <th>SN</th>
    //             <th>Voucher No.</th>
    //             <th>Voucher Type</th>
    //             <th>Narration</th>
    //             <th>Date</th>
    //             <th>Status</th>
    //           </tr>
    //         </thead>

    //         <tbody>
    //           {!hasSearched ? (
    //             <tr>
    //               <td colSpan="6" style={{ textAlign: "center" }}>
    //                 Please select filters and click Get Records
    //               </td>
    //             </tr>
    //           ) : paginatedData.length > 0 ? (
    //             paginatedData.map((item, index) => (
    //               <tr key={item._id || index}>
    //                 <td>
    //                   {(currentPage - 1) * rowsPerPage + index + 1}
    //                 </td>
    //                 <td>{item.voucherNo}</td>
    //                 <td>{item.voucherType}</td>
    //                 <td>{item.narration}</td>
    //                 <td>
    //                   {item.date
    //                     ? new Date(item.date).toLocaleDateString()
    //                     : "-"}
    //                 </td>
    //                 <td>{item.status || "-"}</td>
    //               </tr>
    //             ))
    //           ) : (
    //             <tr>
    //               <td colSpan="6" style={{ textAlign: "center" }}>
    //                 {loading ? "Loading..." : "No results found"}
    //               </td>
    //             </tr>
    //           )}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>

    //   {/* ================= PAGINATION ================= */}
    //   {hasSearched && totalPages > 1 && (
    //     <div className="paymentReceipt-pagination-div">
    //       <button
    //         disabled={currentPage === 1}
    //         onClick={() => setCurrentPage((p) => p - 1)}
    //       >
    //         ⬅ Prev
    //       </button>

    //       <span>
    //         Page {currentPage} of {totalPages}
    //       </span>

    //       <button
    //         disabled={currentPage === totalPages}
    //         onClick={() => setCurrentPage((p) => p + 1)}
    //       >
    //         Next ➡
    //       </button>
    //     </div>
    //   )}
    // </div>
    <div className="">
      Payment Receipt
    </div>
  );
};

export default PaymentReceipt;
